const ERR_MESSAGE = {
  FIELD_BLANK: "this field can not be blank.",
  NUMBER_ONLY: "please enter only number.",
  INVALID_EMAIL: "please enter valid email.",
  USER: "username is required",
  FIRST_NAME: "first name is required",
  NPI: "NPI name is required",
  POSITION: "position is required",
  INVALID_USER_SEATS: "please enter valid user seats",

  MIDDLE_NAME: "middle name is required",
  GREATER_THAN: "please enter less than five digits.",
  USER_NAME: "username can not be blank.",
  OTP_BLANK: "otp cant be blank.",
  BLANK_NEW_PASSWORD: "new password cant be blank.",
  PASSWORD_CONTAIN_CHECK:
    "password should contain at least one number, one alphabet and one special charachter (ex. notenetic@2022)",
  PASSWORD_COUNT_CHECK: "password should contains atleast 8 charachters",
  CONFIRM_PASSWORD_BLANK: "confirm password cant be blank.",
  PASSWORD_DIDNT_MATCH: "confirm password didnt match",
  WEIGHT: "weight is required",
  HEIGHT: "height is required",
  HAIR_COLOR: "hair color is required",
  EYE_COLOR: "eye color is required",
  SIB_CLIENT: "sibling client is required",
  LAST_NAME: "last name is required",
  LOCATION: "location is required",
  RECORD_ID: "record id is required",
  CURRENT_PASSWORD_BLANK: "current password cant be blank.",
  COMPANY_NAME: "company name is required",

  NICK_NAME: "nick name is required",
  GENDER: "gender is required",
  DOB: "date of birth is required",
  SSN: "social security number is required",
  RACE: "race is required",
  RELATION: "relation is required",
  ADDRESS_LINE_ONE: "address one is required",
  ADDRESS_LINE_TWO: "address two is required",
  CITY: "city is required",
  STATE: "state is required",
  ZIP_CODE: "zip code is required",
  MOBILE_PHONE: "mobile phone is required",
  MOBILE_DIGITS: "mobile should be of ten digits",

  COUNTRY_CODE: "country code is required",

  EMAIL: "email is required",
  INSURANCE_TYPE: "insurance type is required",
  POLICY: "policy is required",
  START_DATE: "start date is required",
  END_DATE: "end date is required",
  ASSIGN_SITES: "assign site is required",
  PIN_LENGTH: "pin should have atleast 4 digits",
  PIN_MATCH: "pin and confirm Pin not match",
  INVALID_PIN: "invalid Pin.",

  USERNAME_AVAILABLE: "username already taken. try any other please.",
  DOMAIN_NAME: "domain name already taken. try any other please.",

  POSTION: "position is required",
  ROLE_ID: "role id is required",
  POSITION_EFFECTIVE: "position effective date is required",
  TIMEZONE: "timezone is required",
  MARITIAL_STATUS: "maritial status is required",
  POSITION_NAME: "position name is required",
  POSITION_EFFECTIVE_DATE: "effective date is required",
  POSITION_END_DATE: "position end date is required",
  DIAGNOSIS_DATE: "diagnosis date is required",
  DIAGNOSIS_NAME: "diagnosis name is required",
  CERTIFICATE: "certificate name is required",
  ISSUE_DATE: "issue date is required",
  EXPIRATION_DATE: "expiration date is required",
  DOCUMENT_NAME: "document name is required",
  UPLOAD_DOCUMENT: "documnet is required",

  siteName: "site is requierd",
  ADDRESS: "address is reuired",
  PHONE: "phone number is required ",
  PHONE_LIMIT: "please input 10 digits of phone number",
  fax: "fax is required",
  email: "email is required ",
  licenses: "licenses is required",
  comments: "comments is required",

  CLIENT_ID: "client Id is required",
  CLINIC_ID: "clinic Id is required",
  STAFF_ID: "staff Id is required",
  COMMENT: "comment is required",

  bpSys: "bp sys is required",
  bpDia: "bp dias is required",
  heartRate: "heart rate is required",
  pulseRate: "pulse rate is required",
  temperature: "temperature is required",
  respiration: "respiration is required",
  height: "height is required",
  weight: "weight is required",
  dateRecord: "record date is required",
  endDate: "end date is required ",
  S3_FILE_PATH: "s3 file path is required",

  // ------------------------------insurance Error--------------------------

  INSURANCETYPE: "insurance type is required",
  POILICY: "policy number is required",
  DIAGNOSIS_UPDATE_DATE: "diagnosis is not available for this date",

  //----------------------------Service Error......................
  serviceRate: "service rate is required",
  service: "service is required",
  serviceCode: "service code is required",
  dateEffective: "date effective is required",
  rateDateEffective: "rate date effective is required",
  billingUnitId: "billing unit is required",
  rateEndDate: "rate end date is required",
  REF_NAME: "referral name is required",
  REF_DATE: "referral date is required",
  REASON: "reason is required",
  REGION: "Region name is required",
  TAG: "Tag name is required",
  LABEL: "Label name is required",
  MASTER_CLINIC_ID: "Master clinic id is required"

};

export default ERR_MESSAGE;
